import { render, staticRenderFns } from "./DialogSudent.vue?vue&type=template&id=48d5247e&scoped=true"
import script from "./DialogSudent.vue?vue&type=script&lang=js"
export * from "./DialogSudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5247e",
  null
  
)

export default component.exports